'use client';

import { useEffect } from 'react';
import { listenForOpenUrl } from '@/lib/push/open-url-listener';

export default function ServiceWorkerRegister() {
  // Not deferred: a notification tap can arrive the moment the app resumes.
  useEffect(() => listenForOpenUrl(), []);

  useEffect(() => {
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
    const register = () => {
      navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {});
    };
    type RIC = (cb: () => void, opts?: { timeout: number }) => number;
    const ric = (window as unknown as { requestIdleCallback?: RIC }).requestIdleCallback;
    if (ric) {
      ric(register, { timeout: 5000 });
    } else {
      window.setTimeout(register, 1500);
    }
  }, []);

  return null;
}
